import img1 from '../assets/img1.jpg'
import img2 from '../assets/img2.jpg'
import img3 from '../assets/img3.jpg'
import img4 from '../assets/img4.jpg'
import img5 from '../assets/img5.jpg'
import img6 from '../assets/img6.jpg'
import img7 from '../assets/img7.jpg'
import img8 from '../assets/img8.jpg'
import img9 from '../assets/img9.jpg'
import img10 from '../assets/img10.jpg'
import img11 from '../assets/img11.jpg'
import img12 from '../assets/img12.jpg'
import img13 from '../assets/img13.jpg'
import img14 from '../assets/img14.jpg'
import img15 from '../assets/img15.jpg'
import img16 from '../assets/img16.jpg'
import img17 from '../assets/img17.jpg'
import img18 from '../assets/img18.jpg'
import img19 from '../assets/img19.jpg'
import img20 from '../assets/img20.jpg'
import img21 from '../assets/img21.jpg'
import img22 from '../assets/img22.jpg'
import img23 from '../assets/img23.jpg'
import img24 from '../assets/img24.jpg'
import img25 from '../assets/img25.jpg'
import img26 from '../assets/img26.jpg'
import img27 from '../assets/img27.jpg'
import img28 from '../assets/img28.jpg'
import img29 from '../assets/img29.jpg'
import img30 from '../assets/img30.jpg'

export const MenuData = [{
    name: 'Masala Fries',
    details: 'Snack',
    price: '225',
    img: img1,
    type: 'snack',
},
{
    name: 'Cashew Curry',
    details: 'Curry',
    price: '300',
    img: img2,
    type: 'curry',
},
{
    name: 'Cauliflower Curry',
    details: 'Curry',
    price: '255',
    img: img3,
    type: 'curry',
},
{
    name: 'Chana Chaat',
    details: 'Snack',
    price: '125',
    img: img4,
    type: 'snack',
},
{
    name: 'Chole Chawal',
    details: 'Rice',
    price: '200',
    img: img5,
    type: 'rice',
},
{
    name: 'Coconut Burfi',
    details: 'Sweet',
    price: '215',
    img: img6,
    type: 'sweet',
},
{
    name: "Coconut Ladoo",
    details: 'Sweet',
    price: '300',
    img: img7,
    type: 'sweet'
}
,
{
    name: "Dal Makhani",
    details: 'Rice',
    price: '230',
    img: img8,
    type: 'rice'
},
{
    name: "Kulfi",
    details: 'Sweet',
    price: '100',
    img: img9,
    type: 'sweet'
},
{
    name: "Edamame Curry",
    details: 'Curry',
    price: '200',
    img: img10,
    type: 'curry'
},
{
    name: "Fruit Chaat",
    details: 'Snack',
    price: '140',
    img: img11,
    type: 'snack'
},
{
    name: "Gajar Ka Halwa",
    details: 'Sweet',
    price: '120',
    img: img12,
    type: 'sweet'
},
{
    name: "Gujarati Dal",
    details: 'Curry',
    price: '200',
    img: img13,
    type: 'curry'
},
{
    name: "Corn Chaat",
    details: 'Snack',
    price: '120',
    img: img14,
    type: 'snack'
},
{
    name: "Panner Rice",
    details: 'Rice',
    price: '230',
    img: img15,
    type: 'rice'
},
{
    name: "Chickpea Curry",
    details: 'Curry',
    price: '200',
    img: img16,
    type: 'curry'
},
{
    name: "Panner Masala",
    details: 'Curry',
    price: '210',
    img: img17,
    type: 'curry'
},
{
    name: "Rabdi",
    details: 'Sweet',
    price: '120',
    img: img18,
    type: 'sweet'
},
{
    name: "Kalakand",
    details: 'Sweet',
    price: '120',
    img: img19,
    type: 'sweet'
},
{
    name: "Mirchi Pakoda",
    details: 'Snack',
    price: '120',
    img: img20,
    type: 'snack'
},
{
    name: "Modak",
    details: 'Sweet',
    price: '180',
    img: img21,
    type: 'sweet'
},
{
    name: "Mushroom Curry",
    details: 'Curry',
    price: '200',
    img: img22,
    type: 'curry'
},
{
    name: "Pakoda",
    details: 'Snack',
    price: '120',
    img: img23,
    type: 'snack'
},
{
    name: "Pav Bhaji",
    details: 'Snack',
    price: '120',
    img: img24,
    type: 'snack'
},
{
    name: "Peanut Salad",
    details: 'Snack',
    price: '120',
    img: img25,
    type: 'snack'
},
{
    name: "Rajma Chawal",
    details: 'Rice',
    price: '230',
    img: img26,
    type: 'rice'
},
{
    name: "Rajma Masala",
    details: 'Curry',
    price: '200',
    img: img27,
    type: 'curry'
},
{
    name: "Rice Kheer",
    details: 'Sweet',
    price: '120',
    img: img28,
    type: 'sweet'
},
{
    name: "Samosa",
    details: 'Snack',
    price: '90',
    img: img29,
    type: 'snack'
},
{
    name: "Veg Briyani",
    details: 'Rice',
    price: '300',
    img: img30,
    type: 'rice'
}

]